export default {
  "Skeleton": "_Skeleton_4nyox_1",
  "shine": "_shine_4nyox_1"
};import "ni:sha-256;dGor3ZgtYugy3nVQOIWx-8M1_PeQn3bfDU4la2iLASU";